module.exports = __webpack_public_path__ + "img/countdown-bg.8cec2c1a.png";